import { AloAddress, cleanAloAddress, getDefaultAloAddress } from './AloAddress';
import { AloBase, getDefaultAloBase } from './AloBase'
import { AloConfigPiscine, getDefaultAloConfigPiscine } from './AloConfigPiscine';
import { AloForfait, cleanAloForfait } from './AloForfait';
import { AloMedia, cleanAloMedia, getDefaultAloMedia } from './AloMedia';
import { AloMns, cleanAloMns } from './AloMns';
import { AloPageContent, cleanAloPageContent, getDefaultAloPageContent } from './AloPageContent';
import { AloTemplateCours, cleanAloTemplateCours } from './AloTemplateCours';


export interface AloPiscine extends AloBase {      
    adrId:number
    psnEnable:boolean
    psnDomicile:boolean
    psnLargeurCm:number|null
    psnLongueurCm:number|null
    psnDepthMinCm:number|null
    psnDepthMaxCm:number|null
    address:AloAddress
    acyIds:number[]    
    image:AloMedia
    images:Array<AloMedia>
    content:AloPageContent
    templateCours:AloTemplateCours[]
    fftIds:number[]
    mns:AloMns[]
    config:string
    configPiscine:AloConfigPiscine
    datMinCours:string
    datMaxCours:string
}

export const getDefaultAloPiscine = ():AloPiscine => {
    return {  
        ...getDefaultAloBase(),        
        adrId:0,
        psnEnable:false,
        psnDomicile:false,
        psnLargeurCm:null,
        psnLongueurCm:null,
        psnDepthMinCm:null,
        psnDepthMaxCm:null,
        address:getDefaultAloAddress(),
        acyIds:[],
        image:getDefaultAloMedia(),
        images:[],
        content:getDefaultAloPageContent(),
        templateCours:[],
        fftIds:[],
        mns:[],
        config:'',
        configPiscine:getDefaultAloConfigPiscine(),
        datMinCours:'',
        datMaxCours:''
    }
}

export const cleanAloPiscine = (piscine:AloPiscine) => {
    if(!piscine) return    
    if(!piscine.id) delete piscine.id
    if(!piscine.adrId) delete piscine.adrId
    delete piscine.acyIds    
    cleanAloAddress(piscine.address)    
    piscine.images?.forEach(i => cleanAloMedia(i))
    if(piscine.images.length>0)piscine.image = piscine.images[0]
    cleanAloPageContent(piscine.content)
    piscine.templateCours.forEach(t => cleanAloTemplateCours(t) )    
    piscine.mns.forEach(m => cleanAloMns(m))
    piscine.config = JSON.stringify(piscine.configPiscine)
    delete piscine.configPiscine    
}

